/** Patel Sales warehouse - 102-103 N Center Dr, North Brunswick, NJ */
const ADDRESS_FULL = '102-103 North Center Dr, North Brunswick, NJ 08902';
const ADDRESS_QUERY = encodeURIComponent(ADDRESS_FULL);

/** Approx. pin between 101 and 107 N Center Dr */
export const STORE_COORDS = {
  lat: 40.44745,
  lng: -74.4993,
};

export const contactInfo = {
  phone: '(732) 762-7840',
  phoneHref: 'tel:+17327627840',
  email: 'info@patelsalesonline.com',
  emailHref: 'mailto:info@patelsalesonline.com',
  address: {
    line1: '102-103 North Center Dr',
    line2: 'North Brunswick, NJ 08902',
    full: ADDRESS_FULL,
  },
  hours: [
    { days: 'Monday - Friday', time: '8:00 AM - 6:00 PM' },
    { days: 'Saturday', time: '8:00 AM - 4:00 PM' },
    { days: 'Sunday', time: 'Closed' },
  ],
  // Query-based embed geocodes the real street address (not placeholder lat/lng)
  mapEmbedUrl:
    'https://maps.google.com/maps?q=' + ADDRESS_QUERY + '&z=17&hl=en&output=embed',
  directionsUrl:
    'https://www.google.com/maps/dir/?api=1&destination=' + ADDRESS_QUERY,
  mapsPlaceUrl:
    'https://www.google.com/maps/search/?api=1&query=' + ADDRESS_QUERY,
};

export const inquiryTypes = [
  'General Inquiry',
  'Bulk Order Quote',
  'Product Availability',
  'Order Status',
  'Returns & Exchanges',
  'Business Account',
  'Other',
];

export const contactFaqs = [
  {
    question: 'Do you offer wholesale pricing?',
    answer: 'Yes. Patel Sales provides bulk pricing for restaurants, delis, bakeries, caterers, and other food service businesses. Create an account or request a quote for custom pricing.',
  },
  {
    question: 'What areas do you deliver to?',
    answer: 'Free shipping on orders of $500 or more in 30 mile radius of our location. We also deliver to all areas in NJ, PA, NY, CT, MA, RI, DE,and VA. Please contact us if you’re not in 30 miles of our location for delivery schedule.',
  },
  {
    question: 'How fast will I get a response?',
    answer: 'Our team typically responds within 1 business day. For urgent order questions, please call us directly during business hours.',
  },
  {
    question: 'Can I visit your warehouse?',
    answer: 'Yes, walk-in customers are welcome during business hours. We recommend calling ahead for large bulk orders so we can prepare your items.',
  },
];
